
const vpMenus = document.querySelectorAll('.mobile-nav__item[is-private-sales="hidden"]');

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.startsWith(cookieName)) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return null;
}

function removeCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

const urlParams = new URLSearchParams(window.location.search);
const isVpTrue = urlParams.has('vp_sale') && urlParams.get('vp_sale') === 'true';
var VP_throughUrl = getCookie('VP_throughUrl');
if (vpMenus.length) {
    if (isVpTrue) {
        vpMenus.forEach(menu => menu.setAttribute('is-private-sales', 'visible'));
        setCookie('VP_throughUrl', 'true', 30);
        VP_throughUrl = 'true';
        
    } else if (VP_throughUrl !== 'true') {
        vpMenus.forEach(menu => menu.setAttribute('is-private-sales', 'hidden'));
        setCookie('VP_throughUrl', 'false', 30);
    } else {
        vpMenus.forEach(menu => menu.setAttribute('is-private-sales', 'visible'));
    }
}else{
    if( VP_throughUrl === 'true' ) { 
        setCookie('VP_throughUrl', 'false', 30);
    }
}
if( VP_throughUrl === 'true' ) { 
    document.body.setAttribute("private-sale", true);
}